export default __webpack_public_path__ + "static/media/resources-banner.a236f8d9.png";